module.exports = __webpack_public_path__ + "media/assets/enis-bb0146a5f25fc8a2e0769d7fba8de685.png";